interface Props {
  x: number;
  y: number;
  dx: number;
  width: number;
  height: number;
}

const PriceChartMarker = ({ x, y, height }: Props) => {
  return (
    <>
      <g pointerEvents="none" transform={`translate(${x})`}>
        <line
          x1="0"
          y1="-100"
          x2="0"
          y2={height}
          strokeWidth="1"
          stroke="var(--chart-point-line)"
          // strokeDasharray="5, 5"
        />
        {/* <line
          x1={-(x + dx)}
          y1={y}
          x2={width}
          y2={y}
          strokeWidth="1"
          stroke="var(--chart-point-line)"
          strokeDasharray="5, 5"
        /> */}
        <circle
          cx="0"
          cy={y}
          r="5"
          fill="var(--chart-marker-color)"
          stroke="var(--chart-background-color)"
          strokeWidth="2"
        />
      </g>
      {/* <g transform={`translate(${x}, -8)`}>
        <path
          d={`M${(x || 0) + dx < width / 2 ? 4 : -4} 0 L0 0 L0 5 z`}
          fill="var(--chart-box-background-color)"
        />
      </g> */}
    </>
  );
};

export default PriceChartMarker;
